import { IApplicationState } from '../../types/redux';

export const selectModalType = (state: IApplicationState) => state.modal.type;
